module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7qIjej/images/cover.jpg?1685204507426",
      "alt": "This image is the cover for the book The Believing Scientist"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Believing Scientist\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Elegant writings by a cutting-edge research scientist defending traditional theological and philosophical positions")]), _c('br'), _c('br'), _vm._v(" Both an accomplished theoretical physicist and a faithful Catholic, Stephen Barr in this book addresses a wide range of questions about the relationship between science and religion, providing a beautiful picture of how they can coexist in harmony."), _c('br'), _c('br'), _vm._v(" In his first essay, \"Retelling the Story of Science,\" Barr challenges the widely held idea that there is an inherent conflict between science and religion. He goes on to analyze such topics as the quantum creation of universes from nothing, the multiverse, the Intelligent Design movement, and the implications of neuroscience for the reality of the soul."), _c('br'), _c('br'), _vm._v(" Including reviews of highly influential books by such figures as Edward O. Wilson, Richard Dawkins, Stephen Jay Gould, Francis S. Collins, Michael Behe, and Thomas Nagel, "), _c('i', [_vm._v("The Believing Scientist")]), _vm._v(" helpfully engages pressing questions that often vex religious believers who wish to engage with the world of science.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Barr\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0